import React from "react"
import PropTypes from "prop-types"

const ContactInfo = ({ email }) => {
  const [mounted, setMounted] = React.useState(false)
  React.useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return (
      <ul>
        <li>
          <strong>Wiltshire Jones</strong>
        </li>
      </ul>
    )
  }

  return (
    <ul>
      <li>
        <strong>Wiltshire Jones</strong>
      </li>
      <li>602 Hidden Village Dr, Perth Amboy, NJ 08861</li>
      <li>Email: {email}</li>
      <li>Phone: +1 732-757-8056</li>
    </ul>
  )
}

ContactInfo.propTypes = {
  email: PropTypes.string.isRequired,
}

export default ContactInfo
